import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "constants/MasterConfigContext";
import Head from "next/head";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { useWindowSize } from "api/commonConstants";
import { Container } from "react-bootstrap";
import { baseUrl } from "api/constants";
import Tally from "components/tally/Tally";
import { stateData } from "constants/state";
const StateKeyCandidateD = ({ keyCandidatesData , breadCrump ,  stateName, stateNameHi , propData , masterKey , electionState }) => {
  // const [keyCandidatesData, setKeyCandidatesData] = useState([]);
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig?.vidhansabha_election;
  const DEFAULT_IMAGE = 'https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/default-partylogo.jpg'

  //old data 
  // const electionsData = masterConfig;
  // electionsData
  const electionsData = masterConfig?.[masterKey];
  
  const showKeyCand = true;
  const size = useWindowSize();



  const router = useRouter();

  const [electionTopicData, setElectionTopicData] = useState([]);
  useEffect(async () => {
    let dataFetched;
    const datas = await fetch(
      `${baseUrl}/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog`
    );
    dataFetched = await datas?.json();
    dataFetched = dataFetched?.result?.entities;
    setElectionTopicData(dataFetched);
  }, []);

  const getKeyCandidatesData = async () => {
    try {
      // const response = await fetch(
      //   `https://electionresults.intoday.in/elections/${electionsData?.displayYear}/assembly-elections/json/ei-dashboard/${electionsData?.displayYear}/key-candidate/${
      //     stateName == "Jammu and Kashmir" ? "jammu-and-kashmir" : "haryana"
      //   }-key-candidate.json`
      // );
      const response = await fetch(propData.dataUrl)
      const data1 = await response.json();
      
      let tempData = data1?.data["ALL KEY CANDIDATES"];
      
      // if (stateName === "Jammu and Kashmir") {
      //   let keyCandidates = tempData?.filter(
      //     (con) => con?.STATE == "Jammu and Kashmir"
      //   );
      //   setKeyCandidatesData(keyCandidates);
      // } else {
      //   let keyCandidates = tempData?.filter((con) => con?.STATE == "Haryana");
      //   setKeyCandidatesData(keyCandidates);
      // }

      let keyCandidates = tempData?.filter(
            (con) => con?.STATE == propData?.dataKey
          );
          setKeyCandidatesData(keyCandidates);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
              [
                [728, 90],
                [970, 250],
                [970, 90],
              ],
              "div-gpt-ad-1701945163318-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1701945220410-1"
            )
            .addService(googletag.pubads());

          //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-1"
            )
            .addService(googletag.pubads());
            googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_HP_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1701946324333-0"
            )
            .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");

          googletag.enableServices();
        });
      }
      googletag.pubads().refresh();
      // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [

      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);

  // useEffect(() => {
  //   getKeyCandidatesData();
  // }, []);

  console.log("All Data ", keyCandidatesData);

  return (
    <>
      <Head>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org/",
              "@type": "WebPage",
              name: `${stateName} Assembly Election ${electionsData?.displayYear} Key-Candidate List: ${
                stateNameHi
              } विधानसभा चुनाव ${electionsData?.displayYear} के मुख्य-उम्मीदवार की सूची`,
              description: `${stateName} Assembly Election Key-Candidate List:  Check here latest upadtes of ${stateNameHi} विधान सभा चुनाव. Key-candiadate list of parties`,
              keywords: ` ${stateName} Assembly Election Key-Candidate List
                                ${stateName} Assembly Chunav ${electionsData?.displayYear} Key-Candidate List
                                ${stateName} Assembly Election ${electionsData?.displayYear}
                                विधान सभा चुनाव ${electionsData?.displayYear}
                                ${stateNameHi} विधान सभा चुनाव  ${electionsData?.displayYear}
                                ${stateNameHi} चुनाव मुख्य-उम्मीदवार सूची
                                ${stateName} Election ${electionsData?.displayYear}
                                ${stateNameHi} विधान सभा चुनाव मुख्य-उम्मीदवार`,
              url: `${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`,
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                url: "https://www.thelallantop.com/",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                  width: 600,
                  height: 60,
                },
              },
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                    name: `${"Home"}`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `${stateName} Assembly Chunav`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}election/${electionState}`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: `${stateName} Key Candidates`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}election/${electionState}/key-candidates`,
                  },
                },
              ],
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SiteNavigationElement",
              name: [
                "होम",
                "चुनाव",
                "न्यूज़",
                "एंटरटेनमेंट",
                "ऑडनारी",
                "टेक्नोलॉजी",
                "पड़ताल",
                "बिज़नेस",
                "लल्लनख़ास",
                "स्पोर्ट्स",
                "रंगरूट",
              ],
              url: [
                "https://www.thelallantop.com/",
                "https://www.thelallantop.com/election",
                "https://www.thelallantop.com/news",
                "https://www.thelallantop.com/entertainment",
                "https://www.thelallantop.com/oddnaari",
                "https://www.thelallantop.com/technology",
                "https://www.thelallantop.com/factcheck",
                "https://www.thelallantop.com/business",
                "https://www.thelallantop.com/lallankhas",
                "https://www.thelallantop.com/sports",
                "https://www.thelallantop.com/education",
              ],
            }),
          }}
        ></script>
        <link
          rel="preconnect"
          crossOrigin="true"
          href="https://static.chartbeat.com"
        ></link>

        <script
          async
          dangerouslySetInnerHTML={{
            __html: `
            (function () {
              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
              _sf_async_config.uid = 60355;
              _sf_async_config.domain = 'thelallantop.com';
              _sf_async_config.useCanonical = true;
              _sf_async_config.useCanonicalDomain = true;
              _sf_async_config.sections = 'home'; 
              _sf_async_config.authors = '';
              function loadChartbeat() {
                  var e = document.createElement('script');
                  var n = document.getElementsByTagName('script')[0];
                  e.type = 'text/javascript';
                  e.async = true;
                  e.src = '//static.chartbeat.com/js/chartbeat.js';
                  n.parentNode.insertBefore(e, n);
              }
              loadChartbeat();
          })();
       `,
          }}
          strategy="afterInteractive"
          id="chartbeat"
          type="text/javascript"
        ></script>
      </Head>
      <NextSeo
        title={`${stateName} Assembly Election ${electionsData?.displayYear} Key-Candidate List: ${
          stateNameHi
        } विधानसभा चुनाव ${electionsData?.displayYear} के मुख्य-उम्मीदवार की सूची`}
        description={`${stateName} Assembly Election Key-Candidate List:  Check here latest upadtes of ${stateNameHi} विधान सभा चुनाव. Key-candiadate list of parties`}
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`}
      />
      <meta
        name="keywords"
        content={`${stateName} Assembly Election Key-Candidate List
        ${stateName} Assembly Chunav ${electionsData?.displayYear} Key-Candidate List
        ${stateName} Assembly Election ${electionsData?.displayYear}
        विधान सभा चुनाव ${electionsData?.displayYear}
        ${stateNameHi} विधान सभा चुनाव  ${electionsData?.displayYear}
        ${stateNameHi} चुनाव मुख्य-उम्मीदवार सूची
        ${stateName} Election ${electionsData?.displayYear}
        ${stateNameHi} विधान सभा चुनाव मुख्य-उम्मीदवार`}
      />

      {size.width > 600 ? (
        <div>
          {size.width >= 600 && (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {router.asPath.includes("election") && (
                <div style={{ position: "relative" }}>
                  <img
                    src={"/assets/images/election-background-3.png"}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "298px",
                    }}
                  ></img>
                  <img
                    src="/assets/images/left-election-top-2.png"
                    width=""
                    height="170px"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                    }}
                  ></img>
                  <img
                    src={
                      router.asPath.includes("haryana-assembly")
                        ? "/assets/images/right-election-top-2.png"
                        : router.asPath.includes("jammu-kashmir-assembly")
                        ? "/assets/images/jammu-kashmir.png"
                        : "/assets/images/indian-map.png"
                    }
                    width=""
                    height="250px"
                    style={{ position: "absolute", bottom: "0", right: "0px" }}
                  ></img>
                </div>
              )}
              <Container
                align="center"
                style={{
                  position: router.asPath.includes("/election")
                    ? "absolute"
                    : "relative",
                  top: router.asPath.includes("/election") ? "22px" : "0px",
                }}
              >
                {/* <Ads
            adName={"/1007232/Lallantop_ROS_728x90_300x250"}
            keyBindings={{
              category: [router.query?.categoryName],
              keywords: metaTags[category]?.metaKeyword,
            }}
          /> */}

                <div className="container-row py-2" align="center">
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#b7b7b7",
                      textAlign: "center",
                      marginBottom: "0px",
                    }}
                  >
                    Advertisement
                  </p>
                  <div
                    id="div-gpt-ad-1701945163318-0"
                    style={{
                      minWidth: "300px",
                      minHeight: "100px",
                      display: "block !important",
                      alignContent: "center",
                      textAlign: "-webkit-center",
                    }}
                    className="ads-auto-resize"
                  >
                    <script
                      type="text/javascript"
                      dangerouslySetInnerHTML={{
                        __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`,
                      }}
                    ></script>
                  </div>
                </div>
              </Container>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div style={{ position: "relative", width: "100%" }}>
            <img
              src={"/assets/images/election-background-mobile.png"}
              style={{ position: "relative", width: "100%", height: "auto" }}
            ></img>
            <img
              src="/assets/images/election-left-mobile.png"
              width=""
              height="70px"
              style={{ position: "absolute", bottom: "10px", left: "10px" }}
            ></img>
            <img
              src={
                router.asPath.includes("haryana-assembly")
                  ? "/assets/images/right-election-top-2.png"
                  : router.asPath.includes("jammu-kashmir-assembly")
                  ? "/assets/images/jammu-kashmir.png"
                  : "/assets/images/indian-map.png"
              }
              width=""
              height="90px"
              style={{ position: "absolute", bottom: "0", right: "0px" }}
            ></img>
          </div>
        </div>
      )}

      {size.width > 768 ? 

        //breadcrump for desktop
      (
        <>
          {(
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                width: "auto",
                margin: "auto",
                gap: "20px",
                minHeight: "80px",
                marginTop: "15px",
                borderRadius: "12px",
                padding: "0px 30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // paddingTop: "1rem",
                  gap: "8px",
                  // cursor: "pointer",
                  backgroundColor: "white",
                  paddingLeft: "0px",
                }}
                // onClick={() =>
                //   window.open("/election/lok-sabha-chunav-${electionsData?.displayYear}", "_self")
                // }
              >
                {/* <div
              style={{ fontSize: "35px", fontWeight: "700", color: "white" }}
            >
              चुनाव
            </div> */}
                <img
                  src="/assets/images/assembly-chunav.png"
                  width="408.56px"
                  height="58.21px"
                  style={{ alignSelf: "center" }}
                ></img>
              </div>
              <div
                class="divCategoriesSchedule2 snipcss-eqdpv"
                style={{
                  margin: "0px 0px",
                  // backgroundColor: "rgb(217, 54, 139)",
                  paddingLeft: "15px",
                  alignContent: "center",
                }}
              >

                  {/* dynamic breadcrump  */}
                {breadCrump.length > 0 && 
                
                breadCrump.map((item , index) => {
                  return electionsData[item.keyToShow] != false ? <a key = {index} href={item.url}>
                  <span>{item.displayText}</span>
                </a> : null
                })
                
              }
               
              </div>
            </div>
          ) }
        </>
      ) :
      
      //breadcrump for mobile
      
      (
        <>
          {
           (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "1rem",
                  gap: "8px",
                  // cursor: "pointer",
                  paddingBottom: "1rem",
                  backgroundColor: "white",
                  marginTop: "10px",
                }}
                // onClick={() =>
                //   window.open("/election/lok-sabha-chunav-${electionsData?.displayYear}", "_self")
                // }
              >
                <img
                  src="/assets/images/assembly-chunav.png"
                  width="240px"
                  height="auto"
                  style={{ alignSelf: "center" }}
                ></img>
              </div>
              <div
                class="divCategoriesSchedule2 snipcss-eqdpv"
                style={{
                  margin: "-1px 0px",
                  backgroundColor: "white",
                  paddingLeft: "15px",
                  paddingBottom: "1rem",
                }}
              >

                 {/* dynamic breadcrump  */}
                 {breadCrump.length > 0 && 
                
                breadCrump.map((item , index) => {
                  return electionsData[item.keyToShow] != false ? <a key = {index} href={item.url}>
                  <span>{item.displayText}</span>
                </a> : null
                })
                
              }
              </div>
            </div>
          )}
        </>
      )}
      <br></br>

      {size.width <= 768 && (
              <div className="container-row py-2" align="center">
                <p
                  style={{
                    fontSize: "11px",
                    color: "#b7b7b7",
                    textAlign: "center",
                    marginBottom: "0px",
                  }}
                >
                  Advertisement
                </p>
                <div
                  id="div-gpt-ad-1701946028239-0"
                  style={{
                    minWidth: "300px",
                    minHeight: "260px",
                    display: "block !important",
                    alignContent: "center",
                    textAlign: "-webkit-center",
                  }}
                  className="ads-auto-resize"
                >
                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                    }}
                  ></script>
                </div>
              </div>
            )}

      <Tally stateName={stateData[electionState].tallyState} masterConfig={electionsData}/>

      {showKeyCand ? (
        <>
          <div className="py-4 px-2 keycand-div">
            <br></br>
            
            <ul
              className="breadcrumb key-bread"
              style={{ justifyContent: "space-between" }}
            >
              <div style={{ display: "flex" }}>
                <li>
                  <a href="/" passHref>
                    <a aria-label="Lallantop Home">
                      <i className="icon-cat-home"></i>
                      <span>Home</span>
                    </a>
                  </a>
                </li>
                <li>
                  {/* <a
                    href={`/election/${
                      stateName === "Haryana" ? "haryana" : "jammu-kashmir"
                    }-assembly-chunav`}
                    passHref
                  > */}
                   <a
                    href={`/election/${
                      electionState
                    }`}
                    passHref
                  >
                    <a aria-label="Lallantop Home">
                      <span>{stateName} Assembly Chunav</span>
                    </a>
                  </a>
                </li>

                {
                  <li>
                    <span>Key Candidates</span>
                  </li>
                }
              </div>
            </ul>
            <div
              style={{
                background: "white",
                padding: size.width >= 768 ? "10px 30px" : "10px 8px",
              }}
            >
              <div className="flex items-center h-full">
                <h1 className="font-bold font-devnagri text-2xl">
                  {stateNameHi} विधानसभा चुनाव {propData['electionYear']} के मुख्य-उम्मीदवार की सूची 
                </h1>
              </div>
              {/* {stateName === "Haryana" ? (
                <div>
                  Haryana Assembly Election ${electionsData?.displayYear} Key-Candidate List: हरियाणा
                  विधानसभा चुनाव में एक तरफ अलग-अलग पार्टियों के बीच टक्कर है,
                  वहीं दूसरी तरफ कई बड़े चेहरों की प्रतिष्ठा भी दांव पर है. कौन
                  से बड़े चेहरे कहां से लड़ रहे हैं चुनाव? जमीन पर कैसे बन-बिगड़
                  रहे हैं समीकरण? क्या होने जा रहा है कोई बड़ा उलटफेर? नीचे दी
                  गई लिस्ट में जानिए पूरा हाल.
                </div>
              ) : (
                <div>
                  Jammu Kashmir Assembly Election ${electionsData?.displayYear} Key-Candidate List:
                  जम्मू-कश्मीर में 10 साल बाद हो रहे विधानसभा चुनावों में टक्कर
                  NC-कांग्रेस गठबंधन और BJP के बीच है. PDP और रशीद इंजीनियर की
                  आवामी पार्टी भी मैदान में हैं. इधर, कुछ बड़े चेहरों की
                  प्रतिष्ठा भी दांव पर है. कौन हैं ये बड़े चेहरे? जमीन पर कैसे
                  बन-बिगड़ रहे हैं समीकरण? क्या होने जा रहा है कोई बड़ा उलटफेर?
                  नीचे दी गई लिस्ट में जानिए पूरा हाल.
                </div>
              )} */}
              <div>
                {propData.textPara}
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  
                  marginBottom: "16px",
                  justifyContent:"space-between"
                }}
              >
                <div
                  style={{ display: "flex", gap: "8px", marginBottom: "16px" , width : size.width < 500 && "100%"}}
                >


                    {propData['tabs'].map((item , index) => {

                     
                      return !(electionsData[item.keyToShow] == false)  ?
                      //  <div className="assembly-buttons width-m-50">
                      <div key = {index}
                        onClick={() =>
                          (window.location.href =
                            item.url)
                        }
                        className={
                          item.showActive
                            ? "assembly-buttons-btn-active"
                            : "assembly-buttons-btn"
                        }
                      >
                        {item.text}
                      {/* </div> */}
                    </div> : null
                    })}

                    
                  {/* <div className="assembly-buttons width-m-50">
                    <div
                      onClick={() =>
                        (window.location.href =
                          "/election/haryana-assembly-chunav/key-candidates")
                      }
                      className={
                        stateName === "Haryana"
                          ? "assembly-buttons-btn-active"
                          : "assembly-buttons-btn"
                      }
                    >
                      हरियाणा
                    </div>
                  </div>
                  {electionsData?.JKkeyCandidate && (
                    <div className="assembly-buttons width-m-50">
                      <div
                        onClick={() =>
                          (window.location.href =
                            "/election/jammu-kashmir-assembly-chunav/key-candidates")
                        }
                        className={
                          stateName !== "Haryana"
                            ? "assembly-buttons-btn-active"
                            : "assembly-buttons-btn"
                        }
                      >
                        जम्मू और कश्मीर
                      </div>
                    </div>
                  )} */}
                </div>
              {size.width >= 768 &&  <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    border: "2px solid rgb(128 128 128 / 46%)",
                    borderRadius: "10px",
                    width: "fit-content",
                    padding: "10px 10px",
                    fontWeight: "700",
                    fontSize: "18px",
                    height:"48px"
                  }}
                >
                  <div style={{height:"fit-content"}}>
                    <span>Lead</span>
                    <img
                      width="18px"
                      height="18px"
                      src="https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
                    ></img>
                  </div>
                  <div style={{height:"fit-content"}}>
                    <span>Trail</span>
                    <img
                      width="18px"
                      height="18px"
                      src="https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
                    ></img>
                  </div>
                  <div style={{height:"fit-content",display:"flex"}}>
                    <span>Won</span>
                    <img
                      style={{ marginLeft: "5px",marginTop:"2px" }}
                      width="18px"
                      height="18px"
                      src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                    ></img>
                  </div>
                  <div style={{height:"fit-content"}}>
                    <span>Lost</span>
                    <img
                      style={{ marginLeft: "5px" }}
                      width="18px"
                      height="18px"
                      src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                    ></img>
                  </div>
                </div>}
              </div>
              <div
                style={{
                  border: "2px solid #E2E2E2",
                  borderTop: "6px solid #E2E2E2",
                  marginTop: "15px",
                }}
              >
                {keyCandidatesData &&
                  keyCandidatesData.length > 0 &&
                  (size.width >= 768 ?
                     (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {keyCandidatesData.map((item, index) => (
                        <div
                          key={index}
                          style={{ width: "50%", padding: "10px" }}
                        >
                          <div
                            style={{
                              backgroundColor: "#F7F9FA",
                              padding: "5px 10px",
                              display: "flex",
                            }}
                          >
                            {
                              <div style={{ width: "7%" }}>
                                {item?.STATUS != "" &&
                                  electionsData
                                    ?.keyCandidate_Win_Loss_Logo && (
                                    <img
                                      src={
                                        item?.STATUS == "WON"
                                          ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                                          : item?.STATUS == "LOST"
                                          ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                                          : item?.STATUS == "TRAILING"
                                          ? "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
                                          : "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
                                      }
                                      alt={item?.CANDIDATE_H}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        objectFit: "none",
                                      }}
                                    />
                                  )}
                              </div>
                            }
                            <div
                              style={{
                                width: "20%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={item?.IMAGE ? item?.IMAGE  : DEFAULT_IMAGE}
                                alt={item?.CANDIDATE_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                width: item?.STATUS == "" ? "65%" : "60%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span 
                                 onClick={() =>{

                                  electionsData.ShowProfileFromKC && item?.CANDIDATE != 'NOTA' ?
                                  window.open(
                                    `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                      electionState
                                    }/candidate-${(
                                      item?.CANDIDATE
                                    )
         
                                      ?.toLowerCase()
                                      .replace(/[^a-zA-Z ]/g, "")
                                      .split(" ")
                                      .join("-")}-${item?.CANDIDATE_ID}-${item?.CID}`,
                                    "_self"
                                  ) : ""
                                }
                                }
                                style={{ fontWeight: "700" , cursor:electionsData.ShowProfileFromKC ? "pointer" : "",
                                  textDecoration:electionsData.ShowProfileFromKC ?  "underline" : "" }}>
                                  {item?.CANDIDATE_H}
                                </span>
                                <span style={{ color: "#808080" }}>
                                  {" "}
                                  ({item?.CONSTITUENCY_H})
                                </span>
                              </div>
                            </div>
                            <div style={{ width: "15%", textAlign: "Center" }}>
                              <img
                                src={item?.PARTY_LOGO}
                                alt={item?.PARTY_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "25px",
                                  height: "25px",
                                  objectFit: "cover",
                                }}
                              />
                              <div>{item?.PARTY_H}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {keyCandidatesData.map((item, index) => (
                        <div
                          key={index}
                          style={{ width: "100%", padding: "6px" }}
                        >
                          <div
                            style={{
                              backgroundColor: "#F7F9FA",
                              padding: "5px 10px",
                              display: "flex",
                              gap: "4px",
                            }}
                          >
                            {
                              <div
                                style={{
                                  width: "15%",
                                  alignContent: "center",
                                }}
                              >
                                {item?.STATUS != "" &&
                                  electionsData
                                    ?.keyCandidate_Win_Loss_Logo && (
                                    <img
                                      src={
                                        item?.STATUS == "WON"
                                          ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                                          : item?.STATUS == "LOST"
                                          ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                                          : item?.STATUS == "TRAILING"
                                          ? "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
                                          : "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
                                      }
                                      alt={item?.CANDIDATE_H}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        objectFit: "none",
                                      }}
                                    />
                                  )}
                              </div>
                            }
                            <div
                              style={{
                                width: "20%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={item?.IMAGE ? item?.IMAGE  : DEFAULT_IMAGE}
                                alt={item?.CANDIDATE_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "30px",
                                  height: "30px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                width: item?.STATUS == "" ? "65%" : "53%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span 
                                 onClick={() =>{

                                  electionsData.ShowProfileFromKC  && item?.CANDIDATE != 'NOTA' ?
                                  window.open(
                                    `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                      electionState
                                    }/candidate-${(
                                      item?.CANDIDATE
                                    )
         
                                      ?.toLowerCase()
                                      .replace(/[^a-zA-Z ]/g, "")
                                      .split(" ")
                                      .join("-")}-${item?.CANDIDATE_ID}-${item?.CID}`,
                                    "_self"
                                  ) : ""
                                }
                                }
                                style={{ fontWeight: "700" , cursor:electionsData.ShowProfileFromKC ? "pointer" : "",
                                  textDecoration:electionsData.ShowProfileFromKC ?  "underline" : "" }}
                                >
                                  {item?.CANDIDATE_H}
                                </span>
                                <span style={{ color: "#808080" }}>
                                  {" "}
                                  ({item?.CONSTITUENCY_H})
                                </span>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "15%",
                                alignContent: "center",
                                textAlign: "center",
                              }}
                            >
                              <img
                                src={item?.PARTY_LOGO}
                                alt={item?.PARTY_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  objectFit: "cover",
                                }}
                              />
                              <div>{item?.PARTY_H}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
              </div>
          {size.width < 768 && <div
                style={{
                  display: "flex",
                  gap: "20px",
                  border: "2px solid rgb(128 128 128 / 46%)",
                  borderRadius: "10px",
                  width: "fit-content",
                  padding: "10px 10px",
                  margin: "auto",
                  marginTop: "10px",
                  fontWeight: "700",
                  fontSize: "18px",
                }}
              >
                <div>
                  <span>Lead</span>
                  <img
                    width="18px"
                    height="18px"
                    src="https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
                  ></img>
                </div>
                <div>
                  <span>Trail</span>
                  <img
                    width="18px"
                    height="18px"
                    src="https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
                  ></img>
                </div>
                <div style={{display:"flex"}}>
                  <span>Won</span>
                  <img
                    style={{ marginLeft: "5px" }}
                    width="18px"
                    height="18px"
                    src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                  ></img>
                </div>
                <div>
                  <span>Lost</span>
                  <img
                    style={{ marginLeft: "5px" }}
                    width="18px"
                    height="18px"
                    src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                  ></img>
                </div>
              </div>}
            </div>
          </div>
          <div className="electionYatra-outer-home" style={{ width: "100% " }}>
            <div className="electionYatra-header">
              <div>
                <img
                  src="/assets/images/election-icon.png"
                  width="35px"
                  height="35px"
                  alt="election-icon"
                ></img>
                <h2 style={{ marginLeft: "10px" , display : "inline-block" }}>विधानसभा चुनाव</h2>
              </div>
              <div
                className="election-aurDekhe"
                onClick={() => router.push("/election")}
              >
                <span style={{ marginRight: "10px" }}>और देखें </span>
                <img
                  src="/assets/images/arrow.png"
                  width="10px"
                  height="10px"
                ></img>
              </div>
            </div>
            <div className="electionYatra-columns">
              {
                <a
                  className="checkMobileOrNot"
                  href={`${electionTopicData[0]?.permalink}`}
                >
                  <div className="electionYatra-second election-mobile">
                    <div
                      className="electionYatra-second-top"
                      style={{ position: "relative" }}
                    >
                      <img src={electionTopicData[0]?.headingImageUrl}></img>
                      <i
                        className={electionTopicData[0]?.type == 'video' ? "icon-play-circle" : 'icon-cat-read'}
                        width="500px"
                        height="500px"
                        style={{
                          color: "white",
                          position: "absolute",
                          left: "2px",
                          bottom: "-5px",
                          width: "500px",
                        }}
                      ></i>
                    </div>
                    <div className="electionYatra-second-bottom">
                      <h3>{electionTopicData[0]?.title}</h3>
                    </div>
                  </div>
                </a>
              }

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {electionTopicData.slice(1).map((x, index) => {
                  return (
                    <a href={`${x?.permalink}`} key={index}>
                      <div className="electionYatra-first">
                        <div className="electionYatra-first-div">
                          <div
                            style={{
                              // flex: "0 0 38%",
                              position: "relative",
                              justifyContent: "center",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={x?.headingImageUrl}
                              width="160px"
                              height="90px"
                            ></img>
                            <i
                      className={x?.type == 'video' ? "icon-play-circle" : 'icon-cat-read'}

                              style={{
                                color: "white",
                                position: "absolute",
                                left: "2px",
                                bottom: "-5px",
                              }}
                            ></i>
                          </div>
                          <div
                            className="electionYatra-first-div-right"
                            style={{ flex: "0 0 60%" }}
                          >
                            <div>
                              <div
                                style={{
                                  overflow: "hidden",
                                }}
                              >
                                <h3
                                  style={{
                                    display: "-webkit-box",
                                    lineHeight: "22px",
                                    WebkitLineClamp: "3",
                                    WebkitBoxOrient: "vertical",
                                    marginTop: "5px",
                                  }}
                                  className="chunav-yatra-small-title"
                                >
                                  {x?.title}
                                </h3>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: "1rem",
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>

              {
                <a
                  style={{ width: "100%" }}
                  className="checkDesktopOrNot"
                  href={`${electionTopicData[0]?.permalink}`}
                >
                  <div className="electionYatra-second election-desktop">
                    <div
                      className="electionYatra-second-top"
                      style={{ position: "relative" }}
                    >
                      <img src={electionTopicData[0]?.headingImageUrl}></img>
                      <i
                        className={electionTopicData[0]?.type == 'video' ? "icon-play-circle" : 'icon-cat-read'}
                        width="500px"
                        height="500px"
                        style={{
                          color: "white",
                          position: "absolute",
                          left: "2px",
                          bottom: "-5px",
                          width: "500px",
                        }}
                      ></i>
                    </div>
                    <div className="electionYatra-second-bottom">
                      <h3>{electionTopicData[0]?.title}</h3>
                    </div>
                  </div>
                </a>
              }
            </div>
          </div>
          <Container align="center">
            <div className="container-row py-2" align="center">
              <p
                style={{
                  fontSize: "11px",
                  color: "#b7b7b7",
                  textAlign: "center",
                  marginBottom: "0px",
                }}
              >
                Advertisement
              </p>
              <div
                id={
                  size.width > 600
                    ? "div-gpt-ad-1701945220410-1"
                    : "div-gpt-ad-1701946028239-1"
                }
                style={{
                  minWidth: "300px",
                  minHeight: size.width > 600 ? "100px" : "260px",
                  display: "block !important",
                  alignContent: "center",
                  textAlign: "-webkit-center",
                }}
              >
                <script
                  type="text/javascript"
                  dangerouslySetInnerHTML={{
                    __html:
                      size.width > 600
                        ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`
                        : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                  }}
                ></script>
              </div>
            </div>{" "}
          </Container>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default StateKeyCandidateD;
